import { useState } from "react";
import { IconSvg } from "../../../../../../../../../../utils/constants/icons/iconSvg.constant";
import "./Filter.scss";
import { classNames } from "../../../../../../../../../../utils/helpers/classNames";
import { CustomSelect } from "../../../../../../../../../../components/ui/CustomSelect/CustomSelect";
import { Button } from "../../../../../../../../../../components/ui/Buttons/Button/Button";
import { DatePicker } from "../../../../../../../../../../components/common/DatePicker/DatePicker";
import { useTranslation } from "../../../../../../../../../../hooks";

export const Filter = () => {
  const { cabinet: { orders: { residential: {
    sortBy, date, locations, reset, cancel, apply
  } } } } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const filterHandler = (e) => {
    e.stopPropagation();
    setIsOpen((current) => !current);
  };

  return (
    <div className="general-filter">
      <div
        className={classNames("general-filter__icon", { "general-filter__icon--open": isOpen })}
        onClick={(e) => filterHandler(e)}
      >
        <IconSvg tag="filter" />
      </div>
      <div className={classNames(
        "general-filter__menu",
        { "general-filter__menu--open": isOpen }
      )}>
        <div className="general-filter__title">{sortBy}</div>
        <div className="general-filter__option">
          <div className="general-filter__option-wrapper">
            <div className="general-filter__label">{date}</div>
            <div className="general-filter__reset">{reset}</div>
          </div>
          <DatePicker
            // startDate={dateFrom}
            // endDate={dateTo}
            // setStartDate={handleDateStart}
            // setEndDate={handleDateEnd}
          />
        </div>
        <div className="general-filter__option">
          <div className="general-filter__option-wrapper">
            <div className="general-filter__label">{locations}</div>
            <div className="general-filter__reset">{reset}</div>
          </div>
          <div className="general-filter__by-location">
            <CustomSelect />
          </div>
        </div>
        <div className="general-filter__actions">
          <Button>{cancel}</Button>
          <Button tab="confirm">{apply}</Button>
        </div>
      </div>
    </div>
  );
};
